import React from 'react';
import ChecklistPage from '../components/checklist/ChecklistPage';
import { SALES_CHECKLIST_PAGE } from '../config/checklistPageConfig';

/** Сохранённый чек-лист отдела продаж (отдельный трек) */
const ReadyForAISalesPage = () => <ChecklistPage pageConfig={SALES_CHECKLIST_PAGE} />;

export default ReadyForAISalesPage;
